import API from '@/services/API'

export default {
  query (queryStringAsJSON, authToken = '') {
    // note the change in URLs for deployment on server, since there are other services running too
    // /database/query for deployment on server
    // /query for local development
    return API().post('/query', queryStringAsJSON, {
      headers: { 'X_METADATA_API_VERSION': '1.8.1', 'authorization': `Bearer ${authToken}` }
    }) // provide Bearer authorization token to use protected REST API endpoints after login automatically
  }
}



// WEBPACK FOOTER //
// ./src/services/QueryService.js